var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-3"},[_c('h2',[_vm._v("总积分榜")]),_c('BarEChart',{attrs:{"chart-data":_vm.total_rating_data,"index":"total-rating-chart","team-name-length":6}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }